import React from 'react';
import VideoHlroomAnalytics from '@sky-it-video/hlroom-analytics';

import TypograpyBodyComponent from '../../foundation/typography/typography-body/typography-body';
import styles from '../../../utils/styles';
import './CategoryFilter.scss';
import { TypographyBody } from '../../foundation';

export interface ICategoryFilter {
  name: string;
  description?: string;
  images: {
    category?: {
      alt?: string;
      desktop?: string;
      mobile?: string;
    };
  };
  tag?: string;
  isDesktop: boolean;
  appType?: string;
}

const CategoryFilter: React.FC<ICategoryFilter> = ({
  name,
  description,
  images,
  tag,
  isDesktop,
  appType = 'sport',
}) => {
  const onClickFn = () => {
    VideoHlroomAnalytics.cleanUrlFromQueryParams('intcmp');
    VideoHlroomAnalytics.analyticsTrack(VideoHlroomAnalytics.CONFIGS[appType].PAGE);
    VideoHlroomAnalytics.setDigitalData(
      { pageName: { subSection: tag as string }, intcmp: tag?.replace(' ', '-') },
      appType
    );
  };
  return (
    <a className={styles('category-filter')} href={`#${tag}`} onClick={() => onClickFn()}>
      <span className={styles('category-filter__title')}>
        <TypographyBody
          text={name}
          typographyClass={appType === 'tg24' ? 'ty-body-medium' : 'ty-body-m--headline-medium'}
        />
      </span>

      <span className={styles('category-filter__description')}>
        <TypograpyBodyComponent text={description!} typographyClass="ty-body-xsmall" />
      </span>

      <div className={styles('category-filter__image')}>
        {images?.category && <img src={images.category[isDesktop ? 'desktop' : 'mobile']} alt={images.category.alt} />}
      </div>

      <div className={styles('category-filter__background')} />
    </a>
  );
};

export default CategoryFilter;
